import React from 'react'
import Icon from 'react-icon-base'

const CloseIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m31.8 10.7l-9.3 9.3 9.3 9.3-2.4 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z" />
    </g>
  </Icon>
)

export default CloseIcon
